import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IMyMonitoringAccountModel } from '@apps-common/types/portal/my-monitoring'

export const updateMyMonitoringAccount = async (model: IMyMonitoringAccountModel): Promise<boolean> =>
  axios.post(`/MyMonitoringAccountManagement/UpdateAccount`, model).then((res) => res?.data?.result)

type Props = {
  model: IMyMonitoringAccountModel
}

export const useUpdateMyMonitoringAccount = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringAccount'],
    mutationFn: ({ model }: Props) => updateMyMonitoringAccount(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Account updated.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to update account.')
      }
    },
    throwOnError: false
  })
